import { ChevronRight } from 'lucide-react';
import { DynamicIcon, IconName } from 'lucide-react/dynamic';
import { FC } from 'react';
import { cn } from '../../utils/cn';
export type OfferTileProps = {
  tagIcon?: IconName;
  tagTitle: string;
  tagClassName?: string;
  className?: string;
  description?: string;
  cta: string;
  url: string;
};

/**
 * A tile card with CTA for offers prompt
 */
export const OfferTile: FC<OfferTileProps> = ({
  tagIcon = 'tag',
  tagTitle,
  tagClassName,
  className,
  description,
  cta,
  url
}) => {
  return <div data-sentry-component="OfferTile" data-sentry-source-file="offer-tile.tsx">
      <div className={cn('bg-pl-blue-800 text-white text-sm rounded-xl p-4 pr-2 space-y-2 relative', className)}>
        <span className={cn('inline-flex items-center gap-1 rounded-full px-2 py-px bg-pl-blue-100 text-pl-blue-800', tagClassName)}>
          <DynamicIcon name={tagIcon} size={10} data-sentry-element="DynamicIcon" data-sentry-source-file="offer-tile.tsx" />
          <span className="text-3xs">{tagTitle}</span>
        </span>
        <h2 className="font-bold">{description}</h2>
        <p className="flex gap-2 items-center text-xs font-bold">
          {cta}
          <ChevronRight size={14} data-sentry-element="ChevronRight" data-sentry-source-file="offer-tile.tsx" />
        </p>
        <a href={url} className="absolute w-full h-full top-0 left-0"></a>
      </div>
    </div>;
};